import axios from "../../axios-instance";
import {createFormData} from "../helpers/form-data-helper";
import {ReportLoader} from "./report-loader";
import {CLASS_NAME_INVISIBLE} from "../constants";
import {FlagMessage, DEFAULT_FLAG_MESSAGE_TIMEOUT, showFlagMessage} from "../flag-message";

class ReportPreview {
  constructor(reportId, reportBlockId, baseReportData, scheduleParams, defaultInternetSpeed, stepManager) {
    this.reportId = reportId;
    this.reportBlockId = reportBlockId;
    this.baseReportData = baseReportData;
    this.scheduleParams = scheduleParams;
    this.defaultInternetSpeed = defaultInternetSpeed;
    this.summary = '';
    this.suggestedActions = '';
    this.internetSpeed = defaultInternetSpeed;
    this.stepManager = stepManager;
    this.loader = null;
    this.updateButtonElement = document.getElementById('executive_summary_report_update');
    this.backButtonElement = document.getElementById('executive_summary_report_go_back');
    this.downloadButtonElement = document.getElementById('executive_summary_report_download');
    this.previewEmailsElement = document.getElementById('executive_summary_schedule_emails');
    this.previewAlertElement = document.getElementById('executive-summary-preview-alert');
    this.scheduleButtonElement = document.getElementById('executive_summary_report_schedule');
    this.summaryTextarea = document.getElementById('executive_summary_overview_textarea');
    this.suggestedActionsTextarea = document.getElementById('executive_summary_suggested_actions_textarea');
    this.internetSpeedSelect = document.getElementById('executive_summary_internet_speed_select');
    this.selectedEmails = [];
    this.showButtons();
    this.showEmails();
    this.showAlert();
    this.initSchedule();
  }

  async loadPreview() {
    const url = `/async_reports/executive_summary/content/${this.reportId}`;
    const response = await axios.get(url);
    const previewIframe = document.getElementById('executive-summary-preview-iframe');
    previewIframe.src = `data:application/pdf;base64, ${response.data.data}`;
  }

  reloadPreviewData(reportId, baseReportData, scheduleParams, defaultInternetSpeed) {
    this.reportId = reportId;
    this.baseReportData = baseReportData;
    this.scheduleParams = scheduleParams;
    this.defaultInternetSpeed = defaultInternetSpeed;
    this.summary = '';
    this.suggestedActions = '';
    this.internetSpeed = defaultInternetSpeed;
    this.summaryTextarea.querySelector('textarea').value = '';
    this.suggestedActionsTextarea.querySelector('textarea').value = '';

    const internetOptions = this.internetSpeedSelect.querySelector('select').options;
    const arrayOptions = Array.apply(null, internetOptions);
    const indexToSelect = arrayOptions.find(option => option.value == defaultInternetSpeed).index;
    this.internetSpeedSelect.querySelector('select').options[indexToSelect].selected = true;
    this.showButtons();
    this.showEmails();
    this.showAlert();
  }

  close () {
    if (this.loader) {
      this.loader.stopLoading();
    }
  }

  initEvents(cannotLoadErrorMessage) {
    const updateReportBtn = document.getElementById('executive_summary_report_update');
    const downloadButton = document.getElementById('executive_summary_report_download');
    const goBackButton = document.getElementById('executive_summary_report_go_back');

    this.initEmailMultiselect();

    updateReportBtn.addEventListener('click', () => {
      const loadingBlock = document.querySelector(`#${this.reportBlockId} .preview .iframe-spinner`).parentElement;
      const errorBlock = document.querySelector(`#${this.reportBlockId} .preview .load-error`);
      const iframeBlock = document.getElementById('executive-summary-preview-iframe');
      const reportData = {...this.baseReportData};
      reportData['summary_overview'] = this.summary;
      reportData['suggested_actions'] = this.suggestedActions;
      reportData['bandwidth_estimate'] = parseInt(this.internetSpeed);
      loadingBlock.classList.remove(CLASS_NAME_INVISIBLE);
      errorBlock.classList.add(CLASS_NAME_INVISIBLE);
      iframeBlock.classList.add(CLASS_NAME_INVISIBLE);
      this.hideButtons();
      axios.post('/async_reports/executive_summary/generate_report', createFormData(reportData)).then(
        response => {
          const taskReportId = response.data.report_id;
          this.reportId = taskReportId;
          this.loader = new ReportLoader(taskReportId);
          this.loader.processLoading().then(r => {
            this.loadPreview().then(r => {
              iframeBlock.classList.remove(CLASS_NAME_INVISIBLE);
              loadingBlock.classList.add(CLASS_NAME_INVISIBLE);
              this.showButtons();
            });
          }).catch(error => {
            this.processLoadReportErrorHandler(loadingBlock, errorBlock, cannotLoadErrorMessage);
          });
        }
      ).catch(error => {
        this.processLoadReportErrorHandler(loadingBlock, errorBlock, cannotLoadErrorMessage);
      });
    });

    this.summaryTextarea.addEventListener('input', (e) => {
      this.summary = this.filterProhibitedInputSymbols(e);
      this.setUpdateButtonVisibility();
    });
    this.suggestedActionsTextarea.addEventListener('input', (e) => {
      this.suggestedActions = this.filterProhibitedInputSymbols(e);
      this.setUpdateButtonVisibility();
    });

    this.internetSpeedSelect.addEventListener('change', (e) => {
      this.internetSpeed = e.target.options[e.target.selectedIndex].value;
      this.setUpdateButtonVisibility();
    });

    downloadButton.addEventListener('click', (e) => {
      const url = `/async_reports/executive_summary/download/${this.reportId}/${this.baseReportData['from_date']}/${this.baseReportData['to_date']}`;
      window.location.href = url;
    });

    goBackButton.addEventListener('click', (e) => {
      this.stepManager.showStep('options');
    });
  }

  initEmailMultiselect = () => {
    const emailRegex = new RegExp(window._email_pattern_js);
    const emailMultiselect = document.getElementById('executive_summary_schedule_emails');

    emailMultiselect.addEventListener('optionSelected', event => {
      const updatedOptions = [];
      emailMultiselect.status = "";
      emailMultiselect.statusMessage = "";
      emailMultiselect.options.forEach(option => {
        const isValid = emailRegex.test(option.value);
        if (isValid) {
          updatedOptions.push(option);
        } else {
          emailMultiselect.status = "error";
          emailMultiselect.statusMessage = `${this.scheduleParams.scheduleEmailError} ${option.value}`;
        }
      });
      emailMultiselect.options = updatedOptions;
      this.scheduleButtonElement.disabled = emailMultiselect.options.length === 0;
    });
  }

  initSchedule() {
    this.scheduleButtonElement.addEventListener('click', () => {
      const reportDefinition = {
        name: this.scheduleParams.reportName,
        delivery_type: this.scheduleParams.deliveryType,
        email_address: Array.from(this.previewEmailsElement.options).map(x => x.value),
        active: 1,
        type: this.scheduleParams.reportType,
        report_params: JSON.stringify({
          'level': this.scheduleParams.level,
          'client_id': this.scheduleParams.clientId,
          'bandwidth_estimate': this.defaultInternetSpeed,
        }),
      };

      axios
          .post('/api/v1/object/report_definition/save', createFormData(reportDefinition))
          .then(response => {

            const isError = parseInt(response.data.is_error) !== 0;
            const flagMessage = showFlagMessage({
              message: response.data.is_error ? 'Error saving report definition.' : this.scheduleParams.scheduleToastValues[this.scheduleParams.selectedFrequency],
              success: !isError,
              error: isError,
              classString: "flag-message-device-page"
            });
            setTimeout(() => {
              flagMessage.remove();
            }, DEFAULT_FLAG_MESSAGE_TIMEOUT);

          })
          .catch(e => {
            const flagMessage = showFlagMessage({
              message: 'Error saving report definition.',
              error: true,
              classString: "flag-message-device-page"
            });
            setTimeout(() => {
              flagMessage.remove();
            }, DEFAULT_FLAG_MESSAGE_TIMEOUT);
          });
    });
  }

  showButtons = () => {
    this.setUpdateButtonVisibility();
    this.backButtonElement.classList.remove(CLASS_NAME_INVISIBLE);
    if (parseInt(this.scheduleParams.selectedSchedule)) {
      this.downloadButtonElement.classList.add(CLASS_NAME_INVISIBLE);
      this.scheduleButtonElement.classList.remove(CLASS_NAME_INVISIBLE);
    } else {
      this.downloadButtonElement.classList.remove(CLASS_NAME_INVISIBLE);
      this.scheduleButtonElement.classList.add(CLASS_NAME_INVISIBLE);
    }
  }

  hideButtons = () => {
    this.updateButtonElement.classList.add(CLASS_NAME_INVISIBLE);
    this.backButtonElement.classList.add(CLASS_NAME_INVISIBLE);
    this.downloadButtonElement.classList.add(CLASS_NAME_INVISIBLE);
    this.scheduleButtonElement.classList.add(CLASS_NAME_INVISIBLE);
  }

  setUpdateButtonVisibility() {
    if (this.summary !== '' || this.suggestedActions !== '' || this.internetSpeed !== this.defaultInternetSpeed) {
      this.updateButtonElement.classList.remove(CLASS_NAME_INVISIBLE);
    } else {
      this.updateButtonElement.classList.add(CLASS_NAME_INVISIBLE);
    }
  }

  showEmails() {
    if (parseInt(this.scheduleParams.selectedSchedule) === 1) {
      this.previewEmailsElement.classList.remove(CLASS_NAME_INVISIBLE);
    } else {
      this.previewEmailsElement.classList.add(CLASS_NAME_INVISIBLE);
    }
  }

  showAlert() {
    if (parseInt(this.scheduleParams.selectedSchedule) === 1) {
      this.previewAlertElement.classList.remove(CLASS_NAME_INVISIBLE);
    } else {
      this.previewAlertElement.classList.add(CLASS_NAME_INVISIBLE);
    }
  }

  filterProhibitedInputSymbols(e) {
    const originalText = e.target.value;
    const filteredText = originalText.replace(/[\r\n]/g, "");
    e.target.value = filteredText;
    return filteredText;
  }

  processLoadReportErrorHandler(loadingBlock, errorBlock, cannotLoadErrorMessage) {
    loadingBlock.classList.add(CLASS_NAME_INVISIBLE);
    errorBlock.classList.remove(CLASS_NAME_INVISIBLE);
    errorBlock.textContent = cannotLoadErrorMessage;
    this.updateButtonElement.classList.remove(CLASS_NAME_INVISIBLE);
  }
}

export {ReportPreview};
